import React from 'react';
import { useStore } from '@/context/StoreContext';
import { Seo } from '@/components/Seo';
import { CGV_FR, CGV_EN, CGV_UPDATED } from '@/lib/cgvContent';

export default function Cgv() {
  const { t, lang } = useStore();
  const sections = lang === 'fr' ? CGV_FR : CGV_EN;
  const updated = new Date(CGV_UPDATED).toLocaleDateString(lang === 'fr' ? 'fr-FR' : 'en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
  const desc = lang === 'fr'
    ? 'Conditions générales de vente NICEWINE : commandes, paiement sécurisé, livraison assurée, rétractation, garanties et protection des données.'
    : 'NICEWINE terms and conditions of sale: orders, secure payment, insured delivery, withdrawal, legal warranties and data protection.';

  return (
    <div className="bg-nw-black">
      <Seo title={t.cgv.title} description={desc} path="/cgv" lang={lang} />
      <div className="relative py-16 border-b border-nw-gold/12">
        <div className="nw-container text-center">
          <div className="nw-eyebrow mb-3">NICEWINE</div>
          <h1 data-testid="cgv-title" className="font-serif text-4xl sm:text-5xl text-nw-ivory">{t.cgv.title}</h1>
          <p className="mt-3 text-nw-warmgrey text-xs tracking-wide">{t.cgv.updated} : {updated}</p>
        </div>
      </div>
      <div className="nw-container py-12 lg:py-16 lg:grid lg:grid-cols-[280px_1fr] lg:gap-14">
        <nav aria-label="Sommaire" className="hidden lg:block">
          <ol className="sticky top-[92px] space-y-2 text-[12px] text-nw-warmgrey max-h-[calc(100vh-120px)] overflow-y-auto pr-3">
            {sections.map((s, i) => (
              <li key={s.id}><a href={`#${s.id}`} className="nw-link inline-flex gap-2"><span className="text-nw-gold/70 w-5 shrink-0">{i + 1}.</span>{s.title}</a></li>
            ))}
          </ol>
        </nav>
        <article data-testid="cgv-content" className="max-w-3xl">
          {sections.map((s, i) => (
            <section key={s.id} id={s.id} className="py-8 border-b border-nw-gold/12 scroll-mt-28">
              <h2 className="font-serif text-2xl text-nw-ivory"><span className="text-nw-gold mr-3">{i + 1}.</span>{s.title}</h2>
              <div className="mt-4 space-y-3 text-sm leading-relaxed text-nw-warmgrey">
                {s.paras.map((p, j) => (p.startsWith('- ')
                  ? <p key={j} className="pl-5 relative before:content-['—'] before:absolute before:left-0 before:text-nw-gold/70">{p.slice(2)}</p>
                  : <p key={j}>{p}</p>))}
              </div>
            </section>
          ))}
        </article>
      </div>
    </div>
  );
}
